/**
 * Story 3.16.1 — Default fallback display para chaves sem formatter
 * customizado. Renderiza JSON pretty-printed em `<pre>` (compatível com
 * o display original do Settings.tsx pre-3.16.1).
 *
 * Use sempre que `settings-display.ts` não tem registry para uma key
 * — mantém non-breaking para keys novas que não foram mapeadas ainda.
 */
export function JsonFallbackDisplay({ value }: { value: unknown }): React.ReactElement {
  return (
    <pre className="max-w-full overflow-x-auto whitespace-pre-wrap break-words rounded bg-muted/40 p-2 text-xs">
      {formatValue(value)}
    </pre>
  )
}

function formatValue(value: unknown): string {
  if (value === null || value === undefined) return 'null'
  if (typeof value === 'string') return value
  try {
    return JSON.stringify(value, null, 2)
  } catch {
    return String(value)
  }
}
